package one.healthium.onboarding.domain.configs


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("relate_to_statement")
data class RelateToStatementScreenConfig(
    @SerialName("title") val title: String? = null,
    @SerialName("subtitle") val subtitle: String? = null,
    @SerialName("cta_title") val ctaTitle: String? = null,
    @SerialName("case_1_title") val case1Title: String? = null,
    @SerialName("case_5_title") val case5Title: String? = null,
) : ScreenConfig
